<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <div>
      <v-subheader class="subtitle-1 whitesmoke font-weight-medium grayBold--text">
        {{ $t("installation_info") }}
      </v-subheader>
      <v-list class="whitesmoke pt-0 tab" min-width="500px">
        <div class="d-flex justify-space-between">
          <v-col class="justify-space-between pa-0">
            <v-list-item v-if="descriptionIsEnabled">
              <v-list-item-content v-if="descriptionIsEnabled">
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("descriptionUpperCase") }}
                </v-list-item-title>
                <v-tooltip top max-width="250px" v-if="installation.info.description && installation.info.description.length > 45">
                  <template v-slot:activator="{ on }">
                    <v-list-item-subtitle class="pt-1 grayBold--text" v-on="on">
                      {{ installation.info.description }}
                    </v-list-item-subtitle>
                  </template>
                  <span class="spanWordWrap" style="color:black">{{ installation.info.description }}</span>
                </v-tooltip>
                <div v-else>
                  <v-list-item-subtitle class="pt-1 grayBold--text">
                    {{ installation.info.description && installation.info.description.length > 0 ? installation.info.description : '-' }}
                  </v-list-item-subtitle>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="descriptionIsEnabled" class="mx-4 mt-2"/>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("address_uppercase") }}
                </v-list-item-title>
                <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.info.address && installation.info.address.length > 0 ? installation.info.address : '-'}} </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("area_uppercase") }}
                </v-list-item-title>
                <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.info.area}} </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-4 mt-2"/>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("floor_uppercase") }}
                </v-list-item-title>
                <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.info.floor && installation.info.floor.length > 0 ? installation.info.floor : '-'}} </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("notes_uppercase") }}
                </v-list-item-title>
                <v-tooltip top max-width="250px" v-if="installation.info.notes && installation.info.notes.length > 45">
                  <template v-slot:activator="{ on }">
                    <v-list-item-subtitle class="pt-1 grayBold--text" v-on="on">
                      {{ installation.info.notes }}
                    </v-list-item-subtitle>
                  </template>
                  <span class="spanWordWrap" style="color:black">{{ installation.info.notes }}</span>
                </v-tooltip>
                <div v-else>
                  <v-list-item-subtitle class="pt-1 grayBold--text">
                    {{ installation.info.notes && installation.info.notes.length > 0 ? installation.info.notes : '-' }}
                  </v-list-item-subtitle>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-4 mt-2"/>
            <v-subheader class="subtitle-1 font-weight-medium grayBold--text">
              {{ $t("tenant_info") }} <v-icon small class="mx-2" color="grayBold" @click="selectClient(installation.info.user_id)" v-if="installation.info.user_id && installation.info.client_is_archived == false">mdi-open-in-new</v-icon>
            </v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("name_uppercase") }}
                </v-list-item-title>
                <v-tooltip top :absolute=true attach max-width="150px">
                  <template v-slot:activator="{ on }">
                    <v-list-item-subtitle class="pt-1 grayBold--text" v-if="installation.info.client_is_archived" v-on="on">
                      <div> {{clientInfoText() }} <v-icon color="#ff9e39"> mdi-alert-circle </v-icon></div>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="pt-1 grayBold--text" v-else>
                      <div> {{clientInfoText() }} </div>
                    </v-list-item-subtitle>
                  </template>
                  <span style="color:black">{{ $t("client_has_been_deleted") }}</span>
                </v-tooltip>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-4 mt-2"/>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                  {{ $t("email") }}
                </v-list-item-title>
                <v-list-item-subtitle class="pt-1 grayBold--text"> {{ installation.info.client_email ? installation.info.client_email : '-'}} </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-4 mt-2"/>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline grayBold--text">
                {{ $t("phone_uppercase") }}
                </v-list-item-title>
                <v-list-item-subtitle class="pt-1 grayBold--text">
                  <tbody v-if="installation.userContacts.length > 0">
                    <tr v-for="item in installation.userContacts" :key="item.phone">
                      <td>
                        <v-icon class="pb-1" small color="primary">{{item.contact_type_id == 1 ? "mdi-cellphone" : "mdi-phone-classic"}}</v-icon>
                        {{ ` ${item.phone}` }}
                      </td>
                      <td v-if="item.is_primary" class="pb-1 ml-4"><v-icon class="pb-1 ml-4" small>mdi-star</v-icon></td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                      <td> - </td>
                      </tr>
                  </tbody>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col v-if="installation.info.latitude && installation.info.longitude" class="justify-space-between pa-0" cols="4">
            <v-list-item>
              <div style="height: 380px;" class="pa-0">
                <l-map :center="center" :zoom="zoom" >
                  <l-tile-layer :url="url"></l-tile-layer>
                  <l-marker :lat-lng="markerCoords"></l-marker>
                </l-map>
              </div>
            </v-list-item>
          </v-col>
        </div>
      </v-list>
    </div>
</template>
  
  
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { commonModule, clientsModule, companyModule } from '@/store/modules/store-accessor'
import { TimeUtil } from '@/helpers/TimeUtil'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Icon } from "leaflet";
  
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


@Component({
  components: {
    LMap, LTileLayer, LMarker
  }
})
export default class InstallationsSideviewGeneralTab extends Vue {
  @Prop() installation: Record<string, any>;

  center = [0, 0];
  zoom = 14;
  url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  markerCoords = [0, 0];

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  @Watch("installation.info.latitude")
  updateMap() {
    this.center = [this.installation.info.latitude, this.installation.info.longitude];
    this.markerCoords = [this.installation.info.latitude, this.installation.info.longitude];
  }

  async mounted() {
    this.center = [this.installation.info.latitude, this.installation.info.longitude];
    this.markerCoords = [this.installation.info.latitude, this.installation.info.longitude];

    await companyModule.getCompanyInfo();
  }

  async selectClient (clientId: string) {
    await clientsModule.getClientsInfo(clientId)
    commonModule.showSideview({ name: 'clients-sideview' , payload: { clientId: clientId} })
  }


  clientInfoText() {
    if(!this.installation.info.client_firstname ) {
      return '-';
    }
    if(this.installation.info.client_is_business) {
      return `${this.installation.info.client_entity_name} (${this.installation.info.client_lastname} ${this.installation.info.client_firstname})`;
    }
    return  this.installation.info.client_lastname + ' ' + this.installation.info.client_firstname;
  }

  get descriptionIsEnabled() {
    return (companyModule.company?.preferences as any)?.installation_description;
  }
  
};
</script>
  
<style scoped lang="scss">
.tab {
  // max-height: calc(70vh - 250px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}

tbody {
      tr:hover {
        background-color: transparent !important;
      }
  }
    .v-tooltip__content {
    background-color: white;
    color: black;
    font-size: 14px;
    margin-left: 120px;
    padding: 8px;
    font-family: Arial, sans-serif;
    border-style: solid;
    border-color: #777777;
    border-width: 1px;
  }
  
  .spanWordWrap {
      display: block;
      width: 200px;
      word-wrap: break-word;
  }
  </style>
  